import React from 'react'

export function AboutLanding() {
  return (
    <div className="about-landing-jumbo" >

    </div>
  )
}
